import axios, { AxiosError } from 'axios'

interface BackendError {
  statusCode: number
  message: string
}

export function isErrorResponse(e: any): e is AxiosError<BackendError> {
  return !!(
    axios.isAxiosError(e) &&
    e &&
    'response' in e &&
    e.response &&
    'data' in e.response &&
    'message' in e.response.data
  )
}
